import { cn } from "@/lib/utils";
import React, { memo, useMemo } from "react";
import Countdown from "react-countdown";

function CustomCount({ onComplete, sec, className = "" }) {
    const countdownDate = useMemo(() => Date.now() + 1000 * sec, [sec]);

    return (
        <Countdown
            date={countdownDate}
            renderer={({ seconds, completed }) =>
                completed ? (
                    <div />
                ) : (
                    <div
                        className={cn(
                            "mx-2 font-Inter text-[12px] leading-[20px] font-medium text-[#00439D]",
                            className
                        )}
                    >
                        ({seconds}s)
                    </div>
                )
            }
            onComplete={onComplete}
        />
    );
}

export default memo(CustomCount);
